import Application from "../../Application";
import { IValueListService } from "../../service/valuelist/ValueListService";

export default class DeleteAttributeReferenceListInteractor {
  private application: Application;
  private valueListService: IValueListService;

  constructor(application, valueListService) {
    this.application = application;
    this.valueListService = valueListService;
  }

  async execute(attributeCode: string) {
    return this.valueListService.deleteValueList(attributeCode);
  }
}
